type BuildRecommendationSentenceArgs = {
  authorName: string;
  companyName: null | string;
  recipientName: string;
  shouldShowCompany: boolean;
};

export const buildRecommendationSentence = ({
  authorName,
  companyName,
  recipientName,
  shouldShowCompany,
}: BuildRecommendationSentenceArgs): string => {
  if (shouldShowCompany) {
    return `${authorName} at ${companyName} hired ${recipientName} and recommends working with them`;
  }

  return `${authorName} recommends working with ${recipientName}`;
};

type ResolveRecommendationsVisibilityArgs = {
  hasPositiveRecommendations: boolean;
  visitorCanEdit: boolean;
};

type ResolveRecommendationsVisibilityReturnType = {
  isRecommendationsTabOnlyVisibleByOwner: boolean;
  shouldShowRecommendations: boolean;
  shouldShowRecommendationsTab: boolean;
};

export const resolveRecommendationsVisibility = ({
  hasPositiveRecommendations,
  visitorCanEdit,
}: ResolveRecommendationsVisibilityArgs): ResolveRecommendationsVisibilityReturnType => {
  const shouldShowRecommendations = hasPositiveRecommendations;

  const shouldShowRecommendationsTab =
    shouldShowRecommendations || visitorCanEdit;
  const isRecommendationsTabOnlyVisibleByOwner =
    !shouldShowRecommendations && visitorCanEdit;

  return {
    isRecommendationsTabOnlyVisibleByOwner,
    shouldShowRecommendations,
    shouldShowRecommendationsTab,
  };
};
